import { repository } from '@woc/woc-repository'

export const infoRepository = repository.create({
  entity: 'info',
  url: 'info',
  allow: 'r',
  childResource: true
})

export default repository.asModule(infoRepository)
